<template>
  <div>
    <div class="btn-group btn-group-sm" role="group">
      <button
        type="button"
        class="btn btn-outline-primary px-4 py-2 mr-2"
        :title="$t('text.clickButtons.editMaintenance')"
        @click="editMaintenance(data)"
      >
        Edit
      </button>
      <div class="btn-group btn-group-sm">
        <button
          type="button"
          class="btn btn-outline-secondary px-4 py-2 mr-2"
          @click="maintenanceRoute(data.id)"
        >
        {{$t('text.clickButtons.maintenance')}}
        </button>
      </div>
      <button
        type="button"
        class="btn btn-outline-danger px-4 py-2"
        :title="$t('text.clickButtons.deleteFault')"
        @click="removeMaintenance(data.id)"
      >
      {{$t('text.actionButtons.delete')}}
      </button>
    </div>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    editMaintenance: function (maint) {
      this.$eventHub.$emit("editMaintenance", maint);
    },

    maintenanceRoute(id) {
      this.$router.push({
        name: "maintenance-details",
        query: { id: id, branchId: this.$route.query.branchId },
      });
    },

    removeMaintenance: function (id) {
      this.$eventHub.$emit("_removeMaintenance", id);
    },
  },
};
</script>